export function seasonYear(season) {
  return Number(
    season?.starts_on?.slice(0, 4) ||
      String(season?.slug || season?.title || "").match(
        /(?:^|\D)(\d{4})(?:\D|$)/,
      )?.[1] ||
      new Date().getFullYear(),
  );
}
export function isApplicationOpen(season, now = new Date()) {
  return (
    season?.status === "recruiting" &&
    (!season.applications_close_on ||
      now <= new Date(`${season.applications_close_on}T23:59:59.999+03:00`))
  );
}
